import { services } from "../data";
import { ServiceCard } from "../components/Cards";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div className="bg-white">
      {/* Header */}
      <section className="relative py-20 lg:py-32 bg-slate-50 overflow-hidden">
        <div className="container-custom relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tighter text-slate-900 mb-6">
              Ydelser & <span className="text-blue-600">Specialopgaver</span>
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed">
              Vi tilbyder en verden af muligheder inden for 3D-teknologi. Uanset om du har brug for en 
              speciel reservedel, en personlig gave eller en kompleks prototype, er vores proces 
              designet til at være fleksibel og løsningsorienteret.
            </p>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-100 -skew-x-12 transform translate-x-20 hidden lg:block"></div>
      </section>

      {/* Main Services */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
            {services.map(service => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>

          {/* Process Section */}
          <div className="bg-slate-50 border border-slate-200 p-8 md:p-16 text-black overflow-hidden relative shadow-sm">
            <div className="relative z-10 max-w-4xl mx-auto">
              <div className="text-center mb-16">
                <span className="text-black font-bold uppercase tracking-widest text-sm mb-4 block">Vores arbejdsproces</span>
                <h2 className="text-3xl md:text-5xl font-semibold tracking-tight">Fra idé til færdigt produkt</h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                {[
                  { title: "Idéfase", desc: "Vi tager en snak om din idé og dine behov for at forstå projektets omfang." },
                  { title: "Design & Prototyping", desc: "Vi udvikler en præcis 3D-model og skaber eventuelt en test-print til godkendelse." },
                  { title: "Endelig Produktion", desc: "Når alt er godkendt, printer vi det endelige emne med højeste præcision." },
                  { title: "Levering", desc: "Vi sikrer en hurtig og sikker levering direkte til din adresse." }
                ].map((step, idx) => (
                  <div key={idx} className="flex gap-6 group">
                    <div className="w-12 h-12 bg-black border border-black shadow-sm rounded-xl flex items-center justify-center font-bold text-white shrink-0 group-hover:bg-slate-800 transition-colors duration-300">
                      {idx + 1}
                    </div>
                    <div>
                      <h4 className="font-bold text-xl mb-2">{step.title}</h4>
                      <p className="text-black leading-relaxed">{step.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute -bottom-10 -right-10 text-[12rem] font-bold text-white/5 select-none pointer-events-none leading-none">
          3DDESIGN
        </div>
        <div className="container-custom text-center relative z-10">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter mb-8">Har du en specifik opgave i tankerne?</h2>
          <p className="text-white mb-8 max-w-xl mx-auto">
            Ingen idé er for lille eller stor. Kontakt os for et uforpligtende tilbud på dit næste projekt.
          </p>
          <Link to="/kontakt" className="btn-primary">
            Kontakt os nu
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
